import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroAccount'), ...new Mutations('xeroAccounts') };
